import React, {useEffect, useState} from "react";
import logo from "../assets/logo.png";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../css/Header.css";
import { useTranslation } from "react-i18next";
import { LanguageSwitcherButton } from "./LanguageSwitcherButton";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import packageInfo from '../../package.json';
import { ApiInfo } from '../functions/ApiCalls';

function Header(/*{ displayNav }*/ {loadAlerts}) {
  const { t, i18n: { language, changeLanguage }  } = useTranslation();
  const { lang } = useParams();
  //var langForAPI;

  const { trackingNumber, referenceNumber } = useParams();
  const location = useLocation();
  const trackingNumberForAPI = (location?.state?.orderNo ?? trackingNumber) ?? referenceNumber; // #6463 - use either the tracking # on the page (preloaded) or the one in the URL address (direct-linking)
  const shouldDisplayVersion = process.env.NODE_ENV.toLowerCase().startsWith ("prod") == false;
  
  async function setupLanguage() {
    let langi18next = language;
    let langParam = lang;

    var currentLang = langi18next;

    // Detect any desired language from the URL Parameters. If none, assume the language from the i18next API
    currentLang = !currentLang ? 'en' : currentLang

    // If the language parameter was specified, and it's different from the urrently selected language in the i18Next library... 
    if (langParam && currentLang.charAt(0) !== langParam.charAt(0))
    {
      var newLang = langParam;

      // reformat the language specified in the URL to match the value required by the localization library:
      let englishKeys = ['e', 'en', 'enca'];
      let frenchKeys = ['f', 'fr', 'frca'];

      let isEnglish = englishKeys.includes (newLang.toLowerCase().replaceAll ('-', ''));
      let isFrench = frenchKeys.includes (newLang.toLowerCase().replaceAll ('-', ''));

      // Use the keys expected by the library
      if (isEnglish) newLang = 'en';
      if (isFrench) newLang = 'fr';

      console.log('Language ' + langParam + ' (translated to ' + newLang + ') was specified in the URL, overriding the current language ' + currentLang + '...');
      // Given the lang parameter, set the appropriate language... Await the result of this, since we set the desired language, which controls what the API provides.
      await changeLanguage(newLang, (err, t1) => {
        if (err) return console.log('Language could not be switched!', err);
        else {currentLang = newLang; console.log('Language switched to ' + currentLang + ' successfully!');}
        //t1('TrackOrderFormPage.title');
      });
    }

    // const langForAPI = language.toLowerCase().startsWith ("en") ? 'E' : 'F';
    // langForAPI = !currentLang ? 'enCA' : currentLang;// Set the default language to english, or 'en'
  }

  useEffect(()=> {
    //console.log  ("Environment: "  + process.env.NODE_ENV);
    //console.log('Component is fully loaded, langauge=' + language);
    setupLanguage();
    
    //console.log ('Header: loadAlerts=' + loadAlerts);
  }, []);
  
  return (
    <>
      <Navbar expand="lg">
        <Container fluid>
          <Navbar.Brand href={"https://appleexpress.com/" + (language.toLowerCase().startsWith("f") ? "fr" : "")}>
            <div style={{textAlign: "center"}}>
              <img
                  className="logo"
                  src={logo}
                  alt="AppleExpress"
                  width="300px"
              ></img>
              {/*
                Display the environment, if not production. If we wanted to show data from the corresponding .env file, we could this way: {process.env.REACT_APP_NAME} {process.env.REACT_APP_VERSION}  where the .env file has defined properties of REACT_APP_NAME=TrackingApp & REACT_APP_VERSION=8.0
              */}  
              <div style={{fontSize: '15px', fontWeight: "bolder", position: "relative", bottom: "15px",  lineHeight: 0,  color: "pink", display: shouldDisplayVersion ? "block" : "none"}}>v{packageInfo.version} {process.env.NODE_ENV}</div>
              <div style={{fontSize: '15px', fontWeight: "bolder", position: "relative", bottom: "0px",  lineHeight: 0,  color: "pink", display: shouldDisplayVersion ? "block" : "none"}}>{ApiInfo.apiVersion ? "API: " + ApiInfo.apiVersion : ""}</div>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav"/>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <LanguageSwitcherButton/>
            <Nav.Link href={language.toLowerCase().startsWith ("en") ? 'https://appleexpress.com/about-us'       : 'https://www.appleexpress.com/fr/a-propos-de-nous/'}>
                {t("Header.about")}
              </Nav.Link>
            <Nav.Link href={language.toLowerCase().startsWith ("en") ? 'https://appleexpress.com/transportation'  : 'https://www.appleexpress.com/fr/transport/'}>
              {t("Header.transportation")}
            </Nav.Link>
            <Nav.Link href={language.toLowerCase().startsWith ("en") ? 'https://appleexpress.com/logistics'       : 'https://www.appleexpress.com/fr/logistique/'}>
              {t("Header.logistics")}
            </Nav.Link>
            <Nav.Link href={language.toLowerCase().startsWith ("en") ? 'https://appleexpress.com/industries'      : 'https://www.appleexpress.com/fr/industries/'}>
              {t("Header.industries")}
            </Nav.Link>
            <Nav.Link href={language.toLowerCase().startsWith ("en") ? 'https://appleexpress.com/infrastructure'  : 'https://www.appleexpress.com/fr/infrastructure/'}>
              {t("Header.infrastructure")}
            </Nav.Link>
            <Nav.Link href={language.toLowerCase().startsWith ("en") ? 'https://appleexpress.com/media'           : 'https://www.appleexpress.com/fr/medias/'}>
                {t("Header.media")}
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
